export const MAX_POST_CHAR_LEN = 235;
export const LIMIT = 30;